import React from 'react';

// components
import PaxJourney from './pax-journey';

// libraries
import { Modal, Button } from 'react-bootstrap';

// redux
import { useSelector } from 'react-redux';
import { selectSelectedFlightToView } from '_redux/slices/timeline/selected-task';
import { selectSelectedViewPassenger } from '_redux/slices/timeline/timeline-control';

// styles
import { Colors } from '_styles';

/**
 * ViewPassenger Component
 *
 * Displays passenger journey details in a modal
 */
const ViewPassenger = ({ onClose }) => {
    // Get passenger and flight data from Redux
    const passenger = useSelector(selectSelectedViewPassenger);
    const flight = useSelector(selectSelectedFlightToView);

    console.log('passenger:', passenger);
    console.log('flight:', flight);
    
    if (!passenger || !flight) return null;

    // Determine flight type for PaxJourney
    const isDeparture = flight?.type === "departure" || flight?.type === "boarding";


    return (
        <div>
            <PaxJourney
                bookingId={passenger?.originalBookingId || passenger?._id}
                type={isDeparture ? 'departure' : 'arrival'}
                flightId={`${flight?.flightNumber}_${flight?.origin}_${flight?.destination}_${flight?.flightDate}`}
            />
        </div>
    );
};

export default ViewPassenger;